import React from 'react'
import {startOfToday, format, addDays, subDays, parseISO} from 'date-fns'
import {generateNewCalendarEvent} from '../Calendar/calendarFunctions'
import { baseUrl } from '../assets/Animations'
import Axios from 'axios'
import TeacherCalendarMonthView from './TeacherPortalCalendarComponents/MonthView/TeacherCalendarMonthView'
import TeacherCalendarLargeViewEvent from './TeacherPortalCalendarComponents/TeacherCalendarLargeViewEvent/TeacherCalendarLargeViewEvent'
import TeacherCalendarWeekView from './TeacherPortalCalendarComponents/WeekView/TeacherCalendarWeekView/TeacherCalendarWeekView'
import NewTeacherCalendarEvent from './TeacherPortalCalendarComponents/NewTeacherCalendarEvent/NewTeacherCalendarEvent'

const TeacherPortalCalendar = (props) => {
  let today = startOfToday()

    const [selectedDay, setSelectedDay] = React.useState({date: today, events: [], availabilities: []})
    const [allEvents, setAllEvents] = React.useState([])
    const [openEvent, setOpenEvent] = React.useState(false)
    const [teacherCalendarView, setTeacherCalendarView] = React.useState('month')
    const [newEvent, setNewEvent] = React.useState(false)
    const [teachersFamilies, setTeachersFamilies] = React.useState([])
    const initialDateTimeRef = React.useRef(null)

    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

  //PALMERS TEACHERID 46a96cf646e5e8

    React.useEffect(() => {
      getTeachersCalendarEvents()
      getTeachersFamilies()

      const refreshCalendarEventsOnWakingUp = () => {
        if (document.visibilityState === 'visible') {
          getTeachersCalendarEvents()
        }
      }

      document.addEventListener('visibilitychange', refreshCalendarEventsOnWakingUp);
      return () => {
        window.removeEventListener('visibilitychange', refreshCalendarEventsOnWakingUp)}
    }, [])

    React.useEffect(() => {
      if(openEvent && initialDateTimeRef.current === null) {initialDateTimeRef.current = openEvent.dateTime}
      if(!openEvent && initialDateTimeRef.current !== null) {initialDateTimeRef.current = null}
    }, [openEvent])

    React.useEffect(() => {
      props.socket.on('createCalendarEvent', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.teacherName === props.userData.Name) {
          setAllEvents(prev => ([...prev, eventPacket.packet]))
        }
      })
      props.socket.on('openCalendarEvent', (eventPacket) => {
        if(eventPacket.packet.teacherName === props.userData.Name) {
          console.log('emitting openCalendarEvent')
        }
      })
      props.socket.on('closeAndSaveCalendarEvent-solo-events', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.response.teacherName === props.userData.Name) {
          setAllEvents(prev => ([...prev.map(event => event.id === eventPacket.packet.response.id ? eventPacket.packet.response : event)]))
        }
      })
      props.socket.on('closeAndSaveCalendarEvent-all-events', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.teacherName === props.userData.Name) {
          setAllEvents(prev => prev.map((e) => (e.id === eventPacket.packet.id ? eventPacket.packet : e)))
        }
      })
      props.socket.on('closeAndSaveCalendarEvent-following-events', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.response[0].data.teacherName === props.userData.Name) {
          if(eventPacket.packet.option === 1) {
            setAllEvents((prev) => ([...prev, eventPacket.packet.response[1].data]))
            setAllEvents((prev) => ([...prev.filter((e) => (e.id !== eventPacket.packet.response[0].data.id))])) 
          } else if (eventPacket.packet.option === 2) {
            setAllEvents((prev) => ([...prev, eventPacket.packet.response[1].data]))
            setAllEvents((prev) => ([...prev.map((e) => (e.id === eventPacket.packet.response[0].data.id ? eventPacket.packet.response[0].data : e))])) 
          }
        }
      })
      props.socket.on('closeAndSaveCalendarEvent-this-event', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet[0].data.teacherName === props.userData.Name) {
          setAllEvents((prev) => ([...prev.map((e) => (e.id === eventPacket.packet[0].data.id ? eventPacket.packet[0].data : e))]))
          setAllEvents((prev) => ([...prev, eventPacket.packet[1].data]))
        }
      })
      props.socket.on('closeAndDeleteCalendarEvent', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.teacherName === props.userData.Name) {
          setAllEvents((prev) => ([...prev.filter((e) => e.id !== eventPacket.packet.id)]))
        }
      })
      props.socket.on('closeAndDeleteCalendarEvent-following-events', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.response.teacherName === props.userData.Name) {
          eventPacket.packet.option === 1 ? setAllEvents((prev) => ([...prev.filter((e) => e.lessonId !== eventPacket.packet.response.lessonId)])) : setAllEvents((prev) => ([...prev.map((e) => (e.id === eventPacket.packet.response.id ? eventPacket.packet.response : e))]))
        }
      })
      props.socket.on('closeAndDeleteCalendarEvent-this-event', (eventPacket) => {
        if(eventPacket.emitter !== props.userData.Name && eventPacket.packet.response.teacherName === props.userData.Name) {
          eventPacket.packet.option === 1 ? setAllEvents((prev) => ([...prev.map((e) => (e.id === eventPacket.packet.response.id ? eventPacket.packet.response : e))])) : setAllEvents((prev) => ([...prev.filter((e) => e.id !== eventPacket.packet.response.id)]))
        }
      })
    }, [props.socket])

    const getTeachersCalendarEvents = () => {
      Axios.get(`${baseUrl}/calendar/teacher/${props.userData.TeacherID}`)
      .then((res) => {
        let filteredResults = res.data.filter(event => !event.isPendingOffer)
        setAllEvents(filteredResults.sort((a, b) => a.dateTime > b.dateTime ? 1 : -1))
      })
      .catch((err) => console.log(err))
    }

    const getTeachersFamilies = () => {
      //TEMP USING PALMER'S TEACHERID --> CHANGE IT TO props.userData.TeacherID
      //Axios.get(`${baseUrl}/teachersfamilies/46a96cf646e5e8`, myHeader)
      Axios.get(`${baseUrl}/teachersfamilies/${props.userData.TeacherID}`, myHeader)
      .then((res) => {
        setTeachersFamilies(res.data)
      })
      .catch((err) => console.log(err))
    }

    const changeWeek = (day, direction) => {
      console.log(day)
      let formattedDay = format(parseISO(day), 'yyyy-MM-dd')
      console.log(formattedDay)
      if(direction === 'forward') {
        formattedDay = format(addDays(selectedDay.date, 7), 'yyyy-MM-dd')
      } else if (direction === 'back') {
        formattedDay = format(subDays(selectedDay.date, 7), 'yyyy-MM-dd')
      }
      setSelectedDay({date: new Date(formattedDay), events: [], availabilities: []})
    }

    const createANewCalendarEvent = () => {
      setNewEvent(generateNewCalendarEvent(selectedDay.date.toISOString(), props.userData.School, props.userData.Name))
      setNewEvent(prev => ({...prev, teacherId: props.userData.TeacherID, teacherImageUrl: props.userData.ImageName, teacherName: props.userData.Name}))
    }

  return (
    <div className='w-full h-full left-0 top-0  overflow-hidden max-w-[600px] min-h-[600px] mx-auto bg-white'>
      <NewTeacherCalendarEvent event={newEvent} setEvent={setNewEvent} setTeachersFamilies={setTeachersFamilies} teachersFamilies={teachersFamilies} setAllEvents={setAllEvents} socket={props.socket} />
      <TeacherCalendarLargeViewEvent event={openEvent} setOpenEvent={setOpenEvent} setAllEvents={setAllEvents} socket={props.socket} initialDateTimeRef={initialDateTimeRef} />
      {teacherCalendarView === 'month' && <TeacherCalendarMonthView selectedDay={selectedDay} setSelectedDay={setSelectedDay} setTeacherCalendarView={setTeacherCalendarView} teacherCalendarView={teacherCalendarView} setOpenEvent={setOpenEvent} createANewCalendarEvent={createANewCalendarEvent} allEvents={allEvents} changeWeek={changeWeek} userData={props.userData} />}
      {(teacherCalendarView === 'week' || teacherCalendarView === 'day') && <TeacherCalendarWeekView selectedDay={selectedDay} setSelectedDay={setSelectedDay} setTeacherCalendarView={setTeacherCalendarView} teacherCalendarView={teacherCalendarView} openEvent={openEvent} setOpenEvent={setOpenEvent} createANewCalendarEvent={createANewCalendarEvent} allEvents={allEvents} />}
      <div onClick={() => createANewCalendarEvent()} className='text-6xl text-white bg-amber-300 cursor-pointer absolute bottom-28 right-4 px-4 py-1 rounded-full text-center align-top shadow-lg shadow-gray-400 border border-solid border-amber-300'>+</div>
    </div>
  )
}
export default TeacherPortalCalendar;